import AzLink from './az-link.vue';

/* istanbul ignore next */
AzLink.install = function (Vue) {
  Vue.component(AzLink.name, AzLink);
};

export default AzLink;
